﻿import clsx from 'clsx';
import React, { LegacyRef, PropsWithChildren } from 'react';
import { BaseProps } from './BaseProps';

export const Menu = React.forwardRef(
  (
    { className, ...props }: PropsWithChildren<BaseProps>,
    ref: LegacyRef<HTMLDivElement> | undefined
  ) => (
    <div className={clsx(className)} {...props} data-test-id="menu" ref={ref} />
  )
);
